<template>
    <v-toolbar
     card
      app
      color="#fff"
      style="color:#666;border-bottom: 1px solid #DFDFDF !important"
      >
      <v-toolbar-title>
        <i class="fa fa-bars" @click.stop="toggleNavigationBar" style="cursor: pointer;"></i>
       </v-toolbar-title>
    
        <v-toolbar-items class="hidden-sm-and-down">
          <template v-if="loader">
              <skeleton-loader-vue :width="150" :height="28" animation="wave" class="mt-3 ml-2" />
          </template>
          <template v-else>
              <span class="mt-4 account-style">
                <!-- &nbsp;&nbsp; {{$store.state.USER_AUTH.user.roles_name}} Account -->
                 &nbsp; ESS ACCOUNT PORTAL
              </span>
          </template>
            
        </v-toolbar-items>
       <v-spacer></v-spacer>

    

        <v-toolbar-items class="hidden-sm-and-down">
          <span class="mt-4 account-style">
            <template v-if="loader">
              <skeleton-loader-vue :width="150" :height="28" animation="wave" />
            </template>
            <template v-else>
                <div v-if="$store.state.USER_AUTH.user.role_id === 6 ">
                  <i class="fa fa-user-circle-o font-icon-user" style="cursor: pointer;"></i>&nbsp;&nbsp; Welcome! BP Owner
                </div>
                <div v-else>
                  <i class="fa fa-user-circle-o font-icon-user" style="cursor: pointer;"></i>&nbsp;&nbsp; {{user.first_name | capitalize}} {{ user.last_name | capitalize}}
                </div>
            </template>
          </span>  
        </v-toolbar-items>
    </v-toolbar>
  </template>
  <script>
    /* eslint-disable */
  export default {
    data() {
      return {
          loader: true
      }
    },
  
      created: function () {
          this.getCurentUser();
      },
    methods: {
       getCurentUser() {
        axios.get('api/getfullname')
          .then(response => {
            this.user = response.data;
            this.loader = false
          })
      },
      toggleNavigationBar() {
        const vm = this;
  
        vm.$emit('toggleNavigationBar');
        console.log('response => ',vm)
        //alert('test')
      },
  
    }
  };
  </script>
  <style>
      .account-style{
          font-size: 16px;
      }
      .font-icon-user{
          font-size: 23px !important;
      }
     .font-icon{
      font-size: 22px !important; 
    }
    .toolbar-menu-item {
      padding-left: 5px;
    }
  
    .selected-language-flag {
      max-width: 45px;
    }
  
    .language-flag {
      max-width: 40px;
    }
  
  
    .languages-list-item {
      cursor: pointer;
      margin-top: -2px;
      margin-left: 1px;
    }
  
    .languages-list-item-title {
      font-size: 16px;
    }
  
    .languages-list-item-title:hover {
      color: #41B883;
      font-weight: bold;
    }
    .language-menu {
      border-radius: 25px;
      width: 235px;
      margin-right: 10px;
    }
    
   
    
  </style>


// WEBPACK FOOTER //
// src/components/core/Toolbar.vue